import script from "./NotificationBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationBadge.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationBadge.vue?vue&type=style&index=0&id=32bd7065&lang=scss&scoped=true"
import "./NotificationBadge.vue?vue&type=style&index=1&id=32bd7065&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32bd7065"]])

export default __exports__